export { useRegisterUrqlErrorTracker } from './useRegisterUrqlErrorTracker';
